export const DataDropdownStatus = [
  { value: 0, text: "--Please Select--" },
  { value: 1, text: "ใช้งาน" },
  { value: 2, text: "ไม่ใช้งาน" },
];
export const DataDropDownInstructorName = [
  { value: 0, text: "--Please Select--" },
  { value: 1, text: "Item1" },
  { value: 2, text: "Item2" },
];
export const DataDropDownTimeTrainning = [
  { value: 0, text: "--Please Select--" },
  { value: 1, text: "Item1" },
  { value: 2, text: "Item2" },
];
export const DataDropdownProvince = [
  { value: 1, text: "R1-ภาคกลาง" },
  { value: 2, text: "R2-ภาคตะวันตก" },
  { value: 3, text: "R3-ภาคตะวันออก" },
  { value: 4, text: "R4-ภาคตะวันออกเฉียงเหนือ" },
  { value: 5, text: "R3-ภาคใต้" },
  { value: 6, text: "R4-ภาคเหนือ" },
];
export const DataDropdownIdDistrict = [
  { value: 1, text: "1033" },
  { value: 2, text: "1018" },
  { value: 3, text: "1046" },
  { value: 4, text: "1043" },
  { value: 5, text: "1030" },
  { value: 6, text: "1036" },
  { value: 7, text: "1026" },
  { value: 8, text: "1002" },
  { value: 9, text: "1019" },
];
export const DataDropdownDistrict = [
  { value: 1, text: "KKN40-ขอนแก่น" },
  { value: 2, text: "NMA30-นครราชสีมา" },
];
export const DataDropdownStatus1 = [
  { value: 0, text: "ทั้งหมด" },
  { value: "draft", text: "รอยืนยัน" },
  { value: "process", text: "รอตรวจสอบการชำระเงิน" },
  { value: "paid", text: "ชำระเงินสำเร็จ" },
  { value: "fail", text: "ชำระเงินไม่สำเร็จ" },
];
export const DataDropdownPermissionType = [
  { value: 0, text: "ทั้งหมด" },
  { value: 1, text: "Super Admin" },
  { value: 2, text: "Admin" },
];
export const DataDropFloor = [
  { value: 0, text: "G Floor" },
  { value: 1, text: "2nd Floor" },
  { value: 2, text: "Leaflet Point" },
];